import { Box, Checkbox, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { ScreenshotAccordion } from "../../../../components/ScreenshotAccordion";
import GuidelineStep from "../components/GuidelineStep";
import microsoft_azure_cloud1 from "./images/microsoft_azure_cloud1.png";
import microsoft_azure_cloud2 from "./images/microsoft_azure_cloud2.png";
import microsoft_azure_cloud3 from "./images/microsoft_azure_cloud3.png";
import microsoft_azure_cloud4 from "./images/microsoft_azure_cloud4.png";
import microsoft_azure_cloud5 from "./images/microsoft_azure_cloud5.png";
import microsoft_azure_cloud6 from "./images/microsoft_azure_cloud6.png";

const requiredRoles = ["Reader", "Key Vault Reader", "Security Reader"];

const MicrosoftAzureCloudGrantRolesSteps = ({ addToExpandedList }) => {
  const colors = useColors();

  return (
    <GuidelineStep title="Grant Azure AD roles to the Application">
      <Typography variant="body1">Login to Azure Portal.</Typography>
      <PrimaryButton
        sx={{ width: "50px" }}
        onClick={() => {
          window.open("https://portal.azure.com/", "_blank");
        }}
      >
        Sign In
      </PrimaryButton>
      <Typography variant="body1">
        Navigate to <b>Management Groups</b>
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud1,
            altext: "Select Microsoft Azure Service",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Select the <b>Tenant Root Group</b> or other applicable Management group
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud2,
            altext:
              "Pick Access Control (IAM) for the selected Subscription/Management Group",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        click on <b>Access Control (IAM)</b>.
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud3,
            altext:
              "Pick Access Control (IAM) for the selected Subscription/Management Group",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Click on <b>Add</b> and select "<b>Add role assignment</b>".
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud4,
            altext: "Select Add role assignment",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Assign the following roles to the Application you've created for{" "}
        <b>Breeze</b>:
      </Typography>
      <Box
        sx={{
          width: "700px",
          backgroundColor: colors.grey_200,
          padding: "16px",
          borderRadius: "8px",
        }}
      >
        <Typography
          variant="subtitle2"
          color={colors.primary_darker}
          gutterBottom
        >
          The list of required roles
        </Typography>
        <Typography variant="body2" gutterBottom>
          Check the box for each completed permission to track the progress
        </Typography>
        {requiredRoles.map((role, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <Checkbox />
            <Typography>{role}</Typography>
          </Box>
        ))}
      </Box>
      <Typography variant="body1">
        After selecting a role, Click on <b>Members</b> and for{" "}
        <b>Assign Access to</b>, select <b>User, Group or service principal</b>
      </Typography>
      <Typography variant="body1">
        Click <b>+ Select Members</b> and pick the Application you've created
        for <b>Breeze</b>.
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud5,
            altext: "Role assignment summary",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Once done, click on <b>Review + Assign</b> to grant the role.
      </Typography>
      <Typography variant="body1">
        For example, Granting the <b>"Reader"</b> role should look like this:
      </Typography>
      <ScreenshotAccordion
        images={[
          {
            file: microsoft_azure_cloud6,
            altext: "Role assignment summary",
          },
        ]}
        onExpanded={addToExpandedList}
      />
      <Typography variant="body1">
        Repeat the process to assign all required roles.
      </Typography>
    </GuidelineStep>
  );
};

export default MicrosoftAzureCloudGrantRolesSteps;
